import { render, staticRenderFns } from "./AxProjectFilePicker.vue?vue&type=template&id=8b2222a2&scoped=true&"
import script from "./AxProjectFilePicker.vue?vue&type=script&lang=ts&"
export * from "./AxProjectFilePicker.vue?vue&type=script&lang=ts&"
import style0 from "./AxProjectFilePicker.vue?vue&type=style&index=0&id=8b2222a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2222a2",
  null
  
)

export default component.exports